
import { Component, Prop, Vue } from 'vue-property-decorator'

import ChatMessageAudioControlComponent from './ChatMessageAudioControlComponent.vue'

import { ChatMessage } from '@/lib/chat/ChatMessage'
import ChatComponent from './ChatComponent.vue'

@Component({
  components: {
    ChatMessageAudioControlComponent
  }
})
export default class ChatMessageAudioComponent extends Vue {
  @Prop() chatMessage!: ChatMessage;

  isPlaying = false;
  progress = 0;
  duration = '00:00';
  playedTime = '00:00';

  get player () {
    return this.$refs.audioPlayer as HTMLAudioElement
  }

  get loggedInUserId () {
    if (this.$store.state.LoggedInUser.user) {
      return this.$store.state.LoggedInUser.user.id
    } else {
      return -1
    }
  }

  mounted () {
    this.player.addEventListener('ended', () => {
      this.isPlaying = false
    })
    this.player.addEventListener('loadeddata', () => {
      this.resetProgress()
      this.duration = this.convertTimeMMSS(this.player.duration)
      this.updateProgressTime()
    })
    this.player.addEventListener('timeupdate', this.onTimeUpdate)
  }

  resetProgress () {
    if (this.isPlaying) this.player.pause()
    this.duration = this.convertTimeMMSS(0)
    this.playedTime = this.convertTimeMMSS(0)
    this.progress = 0
    this.isPlaying = false
    this.updateProgressTime()
  }

  updateProgressTime () {
    this.$emit(
      'update-progress-time',
      this.progress > 1 ? this.playedTime : this.duration
    )
  }

  onUpdateProgress (pos: number) {
    if (pos) this.player.currentTime = pos * this.player.duration
  }

  onTimeUpdate () {
    this.playedTime = this.convertTimeMMSS(this.player.currentTime)
    this.progress = (this.player.currentTime / this.player.duration) * 100
    this.updateProgressTime()
  }

  playback () {
    if (!this.chatMessage) {
      return
    }
    if (this.isPlaying) {
      this.player.pause()
    } else {
      setTimeout(() => this.player.play())
    }
    this.isPlaying = !this.isPlaying
  }

  convertTimeMMSS (seconds: number) {
    return new Date(seconds * 1000).toISOString().substr(14, 5)
  }
}
